import { render, staticRenderFns } from "./StopN.vue?vue&type=template&id=b5768cb4"
import script from "./StopN.vue?vue&type=script&lang=js"
export * from "./StopN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports